"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2769],{

/***/ 89064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ COMPANY_TYPE_LABELS; }
/* harmony export */ });
var COMPANY_TYPE_LABELS = {
    ETC: "기타",
    FINANCE: "금융권",
    FOREIGN: "외국계기업",
    HOSPITAL: "병원",
    MAJOR: "대기업",
    MEDIUM: "중견기업",
    ORGANIZATION: "비영리단체/협회/재단",
    PUBLIC: "공공기관/공기업",
    SMALL_MEDIUM: "중소기업",
    STARTUP: "스타트업",
    STUDENT_ASSOCIATION: "동아리/학생자치단체"
};


/***/ }),

/***/ 55452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_schemaorg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45363);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52737);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var constants_metaData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77482);
/* harmony import */ var _constants_detailTabs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42337);









var CompanyInfoSeo = function(param) {
    var companyInformation = param.companyInformation, _currentTab = param.currentTab, currentTab = _currentTab === void 0 ? "overview" : _currentTab;
    var company = companyInformation.company, thumbnailImage = companyInformation.thumbnailImage, companyIndustry = companyInformation.companyIndustry, descriptions = companyInformation.descriptions;
    var domains = (0,context__WEBPACK_IMPORTED_MODULE_2__/* .useDomain */ .ay)();
    var basePathname = "".concat(domains.protocol, "://").concat(domains.linkareer, "/company-info/").concat(companyInformation.id);
    var pathname = currentTab === "overview" ? basePathname : "".concat(basePathname, "/").concat(_constants_detailTabs__WEBPACK_IMPORTED_MODULE_6__/* .COMPANY_INFO_TABS */ .y[currentTab].path || currentTab);
    var title = "".concat(companyInformation === null || companyInformation === void 0 ? void 0 : companyInformation.company.name, " 채용정보 | 자소서\xb7합격후기\xb7면접후기\xb7Q&A - 링커리어");
    var logoUrl = (thumbnailImage === null || thumbnailImage === void 0 ? void 0 : thumbnailImage.url) || "https://linkareer.com/static/images/linkareer_170131.png";
    var breadcrumbItems = [
        {
            position: 1,
            name: "기업정보",
            item: "https://linkareer.com/company-info"
        },
        {
            position: 2,
            name: company.name,
            item: "https://linkareer.com/company-info/".concat(companyInformation.id)
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(currentTab && currentTab !== "overview" ? [
        {
            position: 3,
            name: _constants_detailTabs__WEBPACK_IMPORTED_MODULE_6__/* .COMPANY_INFO_TABS */ .y[currentTab].name,
            item: "https://linkareer.com/company-info/".concat(companyInformation.id).concat(_constants_detailTabs__WEBPACK_IMPORTED_MODULE_6__/* .COMPANY_INFO_TABS */ .y[currentTab].path ? "/".concat(_constants_detailTabs__WEBPACK_IMPORTED_MODULE_6__/* .COMPANY_INFO_TABS */ .y[currentTab].path) : "")
        }, 
    ] : []));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                title: title,
                description: constants_metaData__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_INFO_META.description */ .k4.description,
                openGraph: {
                    url: pathname,
                    title: title,
                    description: constants_metaData__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_INFO_META.description */ .k4.description,
                    site_name: "링커리어",
                    type: "website",
                    locale: "ko_KR",
                    images: constants_metaData__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_INFO_META.images */ .k4.images
                },
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: constants_metaData__WEBPACK_IMPORTED_MODULE_5__/* .COMPANY_INFO_META.keywords */ .k4.keywords
                    }, 
                ],
                canonical: pathname
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (0,react_schemaorg__WEBPACK_IMPORTED_MODULE_1__/* .jsonLdScriptProps */ .h6)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    name: company.name,
                    url: company.url || pathname,
                    logo: logoUrl
                }, company.address && {
                    address: {
                        "@type": "PostalAddress",
                        streetAddress: company.address,
                        addressCountry: "KR"
                    }
                }, companyIndustry && {
                    knowsAbout: [
                        companyIndustry.primary || "",
                        companyIndustry.secondary || "", 
                    ].filter(Boolean).join(", ")
                }, company.establishedAt && {
                    foundingDate: new Date(company.establishedAt).toISOString()
                }, descriptions[0] && {
                    description: descriptions[0].content.substring(0, 200)
                }))))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .BreadcrumbJsonLd */ .gR, {
                keyOverride: "company-info-breadcrumb",
                itemListElements: breadcrumbItems
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CompanyInfoSeo);


/***/ }),

/***/ 70231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ES": function() { return /* binding */ REVIEW_COUNT_PER_PAGE; },
/* harmony export */   "Qo": function() { return /* binding */ QNA_ANSWER_COUNT_PER_BLOCK_MOBILE; },
/* harmony export */   "UA": function() { return /* binding */ QNA_ANSWER_COUNT_PER_BLOCK; },
/* harmony export */   "Vh": function() { return /* binding */ REQUEST_MODAL_DEFAULT_CONTENT; },
/* harmony export */   "Vt": function() { return /* binding */ RECRUIT_COUNT_PER_PAGE; },
/* harmony export */   "d8": function() { return /* binding */ QNA_BLOCK_COUNT_PER_PAGE; },
/* harmony export */   "eQ": function() { return /* binding */ COVER_LETTER_COUNT_PER_PAGE; },
/* harmony export */   "gL": function() { return /* binding */ REVIEW_COUNT_PER_PAGE_MOBILE; },
/* harmony export */   "hE": function() { return /* binding */ RECRUIT_COUNT_PER_PAGE_MOBILE; },
/* harmony export */   "kR": function() { return /* binding */ QNA_BLOCK_COUNT_PER_PAGE_MOBILE; }
/* harmony export */ });
var RECRUIT_COUNT_PER_PAGE = 10;
var RECRUIT_COUNT_PER_PAGE_MOBILE = 15;
var COVER_LETTER_COUNT_PER_PAGE = 10;
var REVIEW_COUNT_PER_PAGE = 17;
var REVIEW_COUNT_PER_PAGE_MOBILE = 25;
var QNA_BLOCK_COUNT_PER_PAGE = 4;
var QNA_BLOCK_COUNT_PER_PAGE_MOBILE = 7;
var QNA_ANSWER_COUNT_PER_BLOCK = 2;
var QNA_ANSWER_COUNT_PER_BLOCK_MOBILE = 1;
var REQUEST_MODAL_DEFAULT_CONTENT = "[기업정보 수정요청]\n\n기업명: \n\n수정 요청 내용:";


/***/ }),

/***/ 42337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getCompanyInfoActiveTab; },
/* harmony export */   "y": function() { return /* binding */ COMPANY_INFO_TABS; }
/* harmony export */ });
var COMPANY_INFO_TABS = {
    overview: {
        name: "기업개요",
        path: "",
        dataPath: ""
    },
    recruit: {
        name: "채용공고",
        path: "recruit",
        dataPath: "activities"
    },
    coverletter: {
        name: "합격자소서",
        path: "coverletter",
        dataPath: "coverLetters"
    },
    review: {
        name: "합격후기",
        path: "review",
        dataPath: "reviews"
    },
    qna: {
        name: "현직자Q&A",
        path: "qna",
        dataPath: "qna"
    }
};
function getCompanyInfoActiveTab(pathname) {
    if (pathname.includes("/recruit")) return "recruit";
    if (pathname.includes("/coverletter")) return "coverletter";
    if (pathname.includes("/review")) return "review";
    if (pathname.includes("/qna")) return "qna";
    return "overview";
}


/***/ }),

/***/ 87063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_CompanyInfoDetailLayoutDesktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/context/LoginAlertProvider.tsx + 1 modules
var LoginAlertProvider = __webpack_require__(69990);
// EXTERNAL MODULE: ./src/app.feature/companyInfo/main/desktop/components/CompanyInfoCardVertical.tsx
var CompanyInfoCardVertical = __webpack_require__(90881);
// EXTERNAL MODULE: ./src/app.feature/companyInfo/main/utils/formatCompanyInfoCardData.ts
var formatCompanyInfoCardData = __webpack_require__(17251);
;// CONCATENATED MODULE: ./src/app.feature/companyInfo/detail/desktop/contents/DetailOverviewRelated.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 28px;\n\n    width: 1100px;\n    background-color: ",
        ";\n    padding: 32px;\n    border-radius: 8px;\n    border: 1px solid ",
        ";\n\n    > header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding-bottom: 20px;\n\n      > h2 {\n        font-size: 20px;\n        font-weight: bold;\n        line-height: 28px;\n        margin: 0;\n      }\n    }\n    .related-list {\n      display: grid;\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n      gap: 20px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var DetailOverviewRelated = function(param) {
    var companyId = param.companyId;
    var checkLogin = (0,LoginAlertProvider/* useLoginAlert */.eZ)().checkLogin;
    var data = (0,graphql/* useGqlRelatedCompaniesQuery */.tst)({
        variables: {
            companyId: companyId
        },
        fetchPolicy: "cache-first"
    }).data;
    var relatedCompanies = (data === null || data === void 0 ? void 0 : data.relatedCompanies) || [];
    var relatedCompaniesData = (0,formatCompanyInfoCardData/* default */.Z)(relatedCompanies);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "이 기업 조회자가 많이 본 기업"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "related-list",
                children: relatedCompaniesData.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInfoCardVertical/* default */.Z, {
                            data: item,
                            checkLogin: checkLogin,
                            relatedCompanyId: companyId
                        })
                    }, item.companyInformationId);
                })
            })
        ]
    });
};
/* harmony default export */ var contents_DetailOverviewRelated = (DetailOverviewRelated);
var StyledWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "DetailOverviewRelated__StyledWrapper",
    componentId: "sc-d4d1baa8-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.background.bg_8, theme.line.line_3);
});

// EXTERNAL MODULE: ./src/context.ts + 1 modules
var context = __webpack_require__(52737);
// EXTERNAL MODULE: ./src/app.components/modals/ShareModal/index.tsx + 2 modules
var ShareModal = __webpack_require__(20503);
// EXTERNAL MODULE: ./src/app.feature/chatting/chattingContext/module/ChattingContext.tsx + 6 modules
var ChattingContext = __webpack_require__(18944);
// EXTERNAL MODULE: ./src/app.feature/companyInfo/constants/companyType.ts
var companyType = __webpack_require__(89064);
// EXTERNAL MODULE: ./src/components/ActivityListCardItem/module/getLimitNumText.ts
var getLimitNumText = __webpack_require__(36957);
// EXTERNAL MODULE: ./src/svgIcons/Heart.tsx
var Heart = __webpack_require__(80800);
// EXTERNAL MODULE: ./src/svgIcons/ShareLight.tsx
var ShareLight = __webpack_require__(32685);
// EXTERNAL MODULE: ./src/svgIcons/companyInfo/AnalysisIcon.tsx
var AnalysisIcon = __webpack_require__(82379);
// EXTERNAL MODULE: ./src/svgIcons/companyInfo/CbtIcon.tsx
var CbtIcon = __webpack_require__(92788);
// EXTERNAL MODULE: ./src/svgIcons/companyInfo/ChatIcon.tsx
var ChatIcon = __webpack_require__(99119);
// EXTERNAL MODULE: ./src/utils/config.ts
var config = __webpack_require__(15125);
// EXTERNAL MODULE: ./src/app.feature/companyInfo/detail/hooks/useToggleCompanyInterest.ts
var useToggleCompanyInterest = __webpack_require__(79303);
;// CONCATENATED MODULE: ./src/app.feature/companyInfo/detail/desktop/header/CompanyInfoDetailHeader.tsx


function CompanyInfoDetailHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 1100px;\n\n    padding: 91px 0 21px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .company-info {\n      display: flex;\n      align-items: center;\n      gap: 20px;\n\n      .company-logo {\n        width: 140px;\n        height: 100px;\n        padding: 15px;\n        border-radius: 5px;\n        border: solid 1px ",
        ";\n        overflow: hidden;\n        flex-shrink: 0;\n        position: relative;\n        > img {\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n        }\n\n        .badge-hiring {\n          position: absolute;\n          top: 10px;\n          left: 10px;\n          background: #f46161;\n          color: ",
        ";\n          font-size: 11px;\n          font-weight: bold;\n          border-radius: 6px;\n          min-width: 37px;\n          height: 23px;\n          display: inline-flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n\n      .company-details {\n        margin-bottom: 12px;\n        h1 {\n          font-size: 20px;\n          font-weight: bold;\n          line-height: 1.2;\n          margin-bottom: 4px;\n        }\n\n        .company-type {\n          height: 19px;\n          font-size: 13px;\n          line-height: 1.85;\n          letter-spacing: -0.52px;\n          color: ",
        ";\n          & > span:not(:last-child)::after {\n            content: '';\n            display: inline-block;\n            vertical-align: middle;\n            margin: 0 5px;\n            width: 1px;\n            height: 10px;\n            background-color: ",
        ";\n          }\n        }\n      }\n\n      .link-buttons {\n        display: flex;\n        gap: 10px;\n\n        > a,\n        button {\n          min-width: 120px;\n          display: flex;\n          gap: 3px;\n          align-items: center;\n          justify-content: center;\n          padding: 8px 16px;\n          border-radius: 5px;\n          background-color: #f2f6ff;\n          border: none;\n          font-size: 14px;\n          font-weight: 500;\n          color: ",
        ";\n          cursor: pointer;\n        }\n      }\n    }\n\n    .action-buttons {\n      display: flex;\n      height: 40px;\n      gap: 10px;\n      > button {\n        background-color: ",
        ";\n        border: 1px solid ",
        ";\n        border-radius: 8px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        cursor: pointer;\n        &.like-button {\n          width: 141px;\n          font-size: 13px;\n          font-weight: bold;\n        }\n        &.share-button {\n          width: 40px;\n        }\n      }\n    }\n  "
    ]);
    CompanyInfoDetailHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyInfoDetailHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    CompanyInfoDetailHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var CompanyInfoDetailHeader = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var linkareer = (0,context/* useDomain */.ay)().linkareer;
    var checkLogin = (0,LoginAlertProvider/* useLoginAlert */.eZ)().checkLogin;
    var toggleCompanyInterest = (0,useToggleCompanyInterest/* default */.Z)().toggleCompanyInterest;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlShareCompanyMutation */.wzd)(), 1), shareCompany = ref6[0];
    var openChatting = (0,ChattingContext/* useChattingContext */.Y)().openChatting;
    var ref7 = (0,react.useState)(false), openShareModal = ref7[0], setOpenShareModal = ref7[1];
    var handleClickLike = function(e) {
        e.stopPropagation();
        checkLogin(function() {
            var ref;
            if ((ref = data.company) === null || ref === void 0 ? void 0 : ref.id) {
                toggleCompanyInterest(data.company.id, data.viewerInterestedIn);
            }
        });
    };
    var handleCloseShareModal = function() {
        setOpenShareModal(false);
    };
    var handleClickShare = function() {
        setOpenShareModal(true);
    };
    var handleClickChatBtn = function() {
        checkLogin(function() {
            openChatting({
                type: "reportChatOpenChatRoom",
                data: {
                    chatRoomId: "".concat(data.chatRoomId)
                }
            });
        });
    };
    var increaseCompanyShare = function() {
        var ref;
        if (!((ref = data.company) === null || ref === void 0 ? void 0 : ref.id)) {
            return;
        }
        shareCompany({
            variables: {
                companyId: data.company.id
            }
        });
    };
    var _companyType, ref8;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyInfoDetailHeader_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "company-info",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "company-logo",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (ref = data.thumbnailImage) === null || ref === void 0 ? void 0 : ref.url,
                                alt: (ref1 = data.company) === null || ref1 === void 0 ? void 0 : ref1.name
                            }),
                            data.isRecruiting && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "badge-hiring",
                                children: "채용중"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "company-details",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: (ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "company-type",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: companyType/* COMPANY_TYPE_LABELS */.w[(_companyType = data.companyType) !== null && _companyType !== void 0 ? _companyType : ""]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: (ref3 = data.companyIndustry) === null || ref3 === void 0 ? void 0 : ref3.secondary
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "link-buttons",
                                children: [
                                    data.analysisReportId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "/company-analysis/".concat(data.analysisReportId),
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalysisIcon/* default */.Z, {}),
                                            " 기업분석자료"
                                        ]
                                    }),
                                    data.chatRoomId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        onClick: handleClickChatBtn,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatIcon/* default */.Z, {}),
                                            " 실시간 채팅"
                                        ]
                                    }),
                                    data.cbtExamId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "".concat(config/* LINKAREER_ACADEMY_BASE_URL */.$K, "/exam/detail/").concat(data.cbtExamId),
                                        target: "_blank",
                                        rel: "noreferrer noopener",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CbtIcon/* default */.Z, {}),
                                            " 인적성/필기"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "action-buttons",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "like-button",
                        onClick: handleClickLike,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heart/* default */.Z, {
                                width: 16,
                                height: 16,
                                isFilled: data.viewerInterestedIn
                            }),
                            " ",
                            "관심기업",
                            " ",
                            (0,getLimitNumText/* getLimitNumText */.i)({
                                number: (ref8 = (ref4 = data.company) === null || ref4 === void 0 ? void 0 : ref4.interestCount) !== null && ref8 !== void 0 ? ref8 : 0,
                                limit: 9999
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "share-button",
                        onClick: handleClickShare,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLight/* default */.Z, {
                            color: "#333"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal/* default */.Z, {
                shareLink: "https://".concat(linkareer, "/company-info/").concat(data === null || data === void 0 ? void 0 : data.id),
                open: openShareModal,
                onClose: handleCloseShareModal,
                onClick: increaseCompanyShare,
                ogImage: "https://linkareer.com/static/images/company-info.png",
                title: "".concat((ref5 = data.company) === null || ref5 === void 0 ? void 0 : ref5.name, " 채용정보 | 자소서\xb7합격후기\xb7면접후기\xb7Q&A - 링커리어")
            })
        ]
    });
};
/* harmony default export */ var header_CompanyInfoDetailHeader = (CompanyInfoDetailHeader);
var CompanyInfoDetailHeader_StyledWrapper = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "CompanyInfoDetailHeader__StyledWrapper",
    componentId: "sc-4cde6393-0"
})(CompanyInfoDetailHeader_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CompanyInfoDetailHeader_templateObject(), theme.line.line_3, theme.background.bg_8, theme.color.text_2, theme.line.line_2, theme.color.text_1, theme.background.bg_8, theme.line.line_1);
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/generated/graphql.community.ts
var graphql_community = __webpack_require__(35888);
// EXTERNAL MODULE: ./src/app.feature/companyInfo/detail/constants/detailTabs.ts
var detailTabs = __webpack_require__(42337);
;// CONCATENATED MODULE: ./src/app.feature/companyInfo/detail/desktop/tabs/CompanyInfoDetailTabs.tsx


function CompanyInfoDetailTabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 1100px;\n    height: 67px;\n    display: flex;\n    flex-direction: row;\n    gap: 24px;\n\n    .tab-button {\n      background: none;\n      border: none;\n      padding: 16px 8px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      position: relative;\n      transition: all 0.2s ease;\n\n      &:hover {\n        .tab-name {\n          color: ",
        ";\n        }\n      }\n\n      &.active {\n        .tab-name {\n          color: ",
        ";\n          font-weight: 600;\n        }\n\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          height: 2px;\n          background-color: ",
        ";\n        }\n      }\n    }\n\n    .tab-name {\n      font-size: 16px;\n      font-weight: 500;\n      transition: color 0.2s ease;\n    }\n\n    .tab-count {\n      font-size: 12px;\n      font-weight: 500;\n      margin-left: 2px;\n      background-color: ",
        ";\n      padding: 2px 8px;\n      border-radius: 10px;\n    }\n\n    .active .tab-count {\n      background-color: ",
        ";\n      color: #fff;\n    }\n  "
    ]);
    CompanyInfoDetailTabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyInfoDetailTabs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    CompanyInfoDetailTabs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var CompanyInfoDetailTabs = function(param) {
    var companyId = param.companyId;
    var router = (0,next_router.useRouter)();
    var activeTab = (0,detailTabs/* getCompanyInfoActiveTab */.$)(router.pathname);
    var ref = (0,graphql/* useGqlTotalCountsByCompanyIdQuery */.fex)({
        variables: {
            companyId: companyId
        },
        fetchPolicy: "cache-first"
    }), countData = ref.data;
    var ref1 = (0,graphql_community/* useGqlTotalPostsCountsByCompanyIdCommunityQuery */.zr)({
        variables: {
            companyId: companyId
        },
        fetchPolicy: "cache-first",
        context: {
            clientName: "community"
        }
    }), postsCountData = ref1.data;
    var getTabCount = function(tab) {
        switch(tab.dataPath){
            case "reviews":
                return (postsCountData === null || postsCountData === void 0 ? void 0 : postsCountData.reviews.totalCount) || 0;
            case "qna":
                return ((postsCountData === null || postsCountData === void 0 ? void 0 : postsCountData.qnasMentor.totalCount) || 0) + ((countData === null || countData === void 0 ? void 0 : countData.qnasChat.totalCount) || 0);
            default:
                var ref;
                return (countData === null || countData === void 0 ? void 0 : (ref = countData[tab.dataPath]) === null || ref === void 0 ? void 0 : ref.totalCount) || 0;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInfoDetailTabs_StyledWrapper, {
        children: Object.entries(detailTabs/* COMPANY_INFO_TABS */.y).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), tabKey = _param[0], tab = _param[1];
            var count = getTabCount(tab);
            var href = tabKey === "overview" ? "/company-info/".concat(router.query.id) : "/company-info/".concat(router.query.id, "/").concat(tabKey);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                shallow: false,
                scroll: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "tab-button ".concat(activeTab === tabKey ? "active" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tab-name",
                            children: tab.name
                        }),
                        count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tab-count",
                            children: count
                        })
                    ]
                })
            }, tabKey);
        })
    });
};
/* harmony default export */ var tabs_CompanyInfoDetailTabs = (CompanyInfoDetailTabs);
var CompanyInfoDetailTabs_StyledWrapper = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "CompanyInfoDetailTabs__StyledWrapper",
    componentId: "sc-1e25372b-0"
})(CompanyInfoDetailTabs_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CompanyInfoDetailTabs_templateObject(), theme.color.primary_2, theme.color.primary_2, theme.color.primary_2, theme.background.bg_2, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/companyInfo/detail/desktop/layout/CompanyInfoDetailLayoutDesktop.tsx




function CompanyInfoDetailLayoutDesktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    CompanyInfoDetailLayoutDesktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyInfoDetailLayoutDesktop_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: #f5f6f8;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 32px 0 68px;\n\n  section {\n    padding: 32px !important;\n  }\n"
    ]);
    CompanyInfoDetailLayoutDesktop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var CompanyInfoDetailLayoutDesktop = function(param) {
    var companyInformation = param.companyInformation, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlViewCompanyMutation */.Kzo)(), 1), viewCompany = ref7[0];
    (0,react.useEffect)(function() {
        if (companyInformation === null || companyInformation === void 0 ? void 0 : companyInformation.companyId) {
            viewCompany({
                variables: {
                    companyId: (companyInformation === null || companyInformation === void 0 ? void 0 : companyInformation.companyId) || ""
                }
            });
        }
    }, [
        viewCompany,
        companyInformation === null || companyInformation === void 0 ? void 0 : companyInformation.companyId
    ]);
    var ref8 = (0,graphql/* useGqlCompanyInformationNotCachedQueryQuery */.uZn)({
        variables: {
            companyInformationId: (companyInformation === null || companyInformation === void 0 ? void 0 : companyInformation.id) || ""
        },
        fetchPolicy: "cache-and-network",
        skip: !companyInformation
    }), csrData = ref8.data;
    var mergedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, companyInformation), {
        viewerInterestedIn: csrData === null || csrData === void 0 ? void 0 : (ref = csrData.companyInformation) === null || ref === void 0 ? void 0 : ref.viewerInterestedIn,
        company: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, companyInformation.company), {
            interestCount: (csrData === null || csrData === void 0 ? void 0 : (ref1 = csrData.companyInformation) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.company) === null || ref2 === void 0 ? void 0 : ref2.interestCount) || 0,
            viewCount: (csrData === null || csrData === void 0 ? void 0 : (ref3 = csrData.companyInformation) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.company) === null || ref4 === void 0 ? void 0 : ref4.viewCount) || 0,
            shareCount: (csrData === null || csrData === void 0 ? void 0 : (ref5 = csrData.companyInformation) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.company) === null || ref6 === void 0 ? void 0 : ref6.shareCount) || 0
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyInfoDetailLayoutDesktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_CompanyInfoDetailHeader, {
                data: mergedData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_CompanyInfoDetailTabs, {
                companyId: companyInformation.companyId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContentWrapper, {
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_DetailOverviewRelated, {
                        companyId: companyInformation.companyId
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var layout_CompanyInfoDetailLayoutDesktop = (CompanyInfoDetailLayoutDesktop);
var CompanyInfoDetailLayoutDesktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CompanyInfoDetailLayoutDesktop__StyledWrapper",
    componentId: "sc-7ca4048-0"
})(CompanyInfoDetailLayoutDesktop_templateObject());
var StyledContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CompanyInfoDetailLayoutDesktop__StyledContentWrapper",
    componentId: "sc-7ca4048-1"
})(CompanyInfoDetailLayoutDesktop_templateObject1());


/***/ }),

/***/ 79303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29496);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47079);





var useToggleCompanyInterest = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .useGqlToggleCompanyInterestInMutation */ .mHt)(), 2), toggleCompanyInterestMutation = ref[0], loading = ref[1].loading;
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var toggleCompanyInterest = function(companyId, currentIsInterested, relatedCompanyId) {
        var newIsInterested = !currentIsInterested;
        toggleCompanyInterestMutation({
            variables: {
                input: {
                    companyId: companyId,
                    isInterestedIn: newIsInterested
                }
            },
            fetchPolicy: "network-only",
            refetchQueries: [
                generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .GqlCompanyInformationNotCachedQueryDocument */ .NeN,
                generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .GqlPopularCompanyInformationsDocument */ .kGL,
                generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .GqlCompaniesDocument */ .q7V, 
            ],
            update: function(cache, param) {
                var data = param.data;
                if (!(data === null || data === void 0 ? void 0 : data.toggleCompanyInterestIn) || !relatedCompanyId) return;
                var targetQueryOptions = {
                    query: generated_graphql__WEBPACK_IMPORTED_MODULE_1__/* .GqlRelatedCompaniesDocument */ .M04,
                    variables: {
                        companyId: relatedCompanyId
                    }
                };
                var cachedRelatedCompanies = cache.readQuery(targetQueryOptions);
                if (cachedRelatedCompanies === null || cachedRelatedCompanies === void 0 ? void 0 : cachedRelatedCompanies.relatedCompanies) {
                    var updatedRelatedCompanies = cachedRelatedCompanies.relatedCompanies.map(function(company) {
                        if (company.id === companyId) {
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, company), {
                                interestCount: newIsInterested ? company.interestCount + 1 : Math.max(company.interestCount - 1, 0),
                                companyInformation: company.companyInformation ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, company.companyInformation), {
                                    viewerInterestedIn: newIsInterested
                                }) : null
                            });
                        }
                        return company;
                    });
                    cache.writeQuery((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, targetQueryOptions), {
                        data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, cachedRelatedCompanies), {
                            relatedCompanies: updatedRelatedCompanies
                        })
                    }));
                }
            },
            onCompleted: function(data) {
                var isInterested = data.toggleCompanyInterestIn.isInterestedIn;
                enqueueSnackbar(isInterested ? "해당 기업이 관심기업으로 등록되었습니다." : "해당 기업이 관심기업에서 해제되었습니다.", {
                    variant: "success"
                });
            },
            onError: function(error) {
                enqueueSnackbar(error.message, {
                    variant: "error"
                });
            }
        });
    };
    return {
        toggleCompanyInterest: toggleCompanyInterest,
        isLoading: loading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useToggleCompanyInterest);


/***/ }),

/***/ 61844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_CompanyInfoDetailLayoutMobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/context/LoginAlertProvider.tsx + 1 modules
var LoginAlertProvider = __webpack_require__(69990);
// EXTERNAL MODULE: ./src/app.feature/companyInfo/constants/companyType.ts
var companyType = __webpack_require__(89064);
// EXTERNAL MODULE: ./src/app.feature/companyInfo/main/mobile/components/CompanyInfoCardVertical.tsx
var CompanyInfoCardVertical = __webpack_require__(40697);
;// CONCATENATED MODULE: ./src/app.feature/companyInfo/detail/mobile/contents/CompanyInfoRelated.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    margin-top: 10px;\n    background-color: ",
        ";\n    padding: 20px !important;\n\n    > header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding-bottom: 16px;\n\n      > h2 {\n        font-size: 18px;\n        font-weight: bold;\n        line-height: 1.6;\n        margin: 0;\n      }\n    }\n    .related-list {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 40px 10px;\n      > li {\n        min-width: 0px;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CompanyInfoRelated = function(param) {
    var companyId = param.companyId;
    var checkLogin = (0,LoginAlertProvider/* useLoginAlert */.eZ)().checkLogin;
    var data = (0,graphql/* useGqlRelatedCompaniesQuery */.tst)({
        variables: {
            companyId: companyId
        },
        fetchPolicy: "cache-first"
    }).data;
    var relatedCompanies = (data === null || data === void 0 ? void 0 : data.relatedCompanies) || [];
    var relatedCompaniesData = relatedCompanies.map(function(company) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        return {
            companyId: company.id,
            companyInformationId: ((ref = company.companyInformation) === null || ref === void 0 ? void 0 : ref.id) || "",
            companyName: company.name,
            companyLogo: ((ref1 = company.companyInformation) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.thumbnailImage) === null || ref2 === void 0 ? void 0 : ref2.url) || "",
            isHiring: ((ref3 = company.companyInformation) === null || ref3 === void 0 ? void 0 : ref3.isRecruiting) || false,
            isLiked: ((ref4 = company.companyInformation) === null || ref4 === void 0 ? void 0 : ref4.viewerInterestedIn) || false,
            companyType: companyType/* COMPANY_TYPE_LABELS */.w[((ref5 = company.companyInformation) === null || ref5 === void 0 ? void 0 : ref5.companyType) || ""] || "",
            industryType: ((ref6 = company.companyInformation) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.companyIndustry) === null || ref7 === void 0 ? void 0 : ref7.secondary) || "",
            likesCount: company.interestCount,
            viewsCount: company.viewCount
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "이 기업 조회자가 많이 본 기업"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "related-list",
                children: relatedCompaniesData.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInfoCardVertical/* default */.Z, {
                            data: item,
                            checkLogin: checkLogin,
                            relatedCompanyId: companyId
                        })
                    }, item.companyInformationId);
                })
            })
        ]
    });
};
/* harmony default export */ var contents_CompanyInfoRelated = (CompanyInfoRelated);
var StyledWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CompanyInfoRelated__StyledWrapper",
    componentId: "sc-18aab9fb-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.background.bg_8);
});

// EXTERNAL MODULE: ./src/context.ts + 1 modules
var context = __webpack_require__(52737);
// EXTERNAL MODULE: ./src/app.components/modals/ChatAppModal/ChatAppModal.tsx + 1 modules
var ChatAppModal = __webpack_require__(9466);
// EXTERNAL MODULE: ./src/app.components/modals/ShareModal/index.tsx + 2 modules
var ShareModal = __webpack_require__(20503);
// EXTERNAL MODULE: ./src/components/ActivityListCardItem/module/getLimitNumText.ts
var getLimitNumText = __webpack_require__(36957);
// EXTERNAL MODULE: ./src/svgIcons/Heart.tsx
var Heart = __webpack_require__(80800);
// EXTERNAL MODULE: ./src/svgIcons/ShareLight.tsx
var ShareLight = __webpack_require__(32685);
// EXTERNAL MODULE: ./src/svgIcons/companyInfo/AnalysisIcon.tsx
var AnalysisIcon = __webpack_require__(82379);
// EXTERNAL MODULE: ./src/svgIcons/companyInfo/CbtIcon.tsx
var CbtIcon = __webpack_require__(92788);
// EXTERNAL MODULE: ./src/svgIcons/companyInfo/ChatIcon.tsx
var ChatIcon = __webpack_require__(99119);
// EXTERNAL MODULE: ./src/utils/config.ts
var config = __webpack_require__(15125);
// EXTERNAL MODULE: ./src/app.feature/companyInfo/detail/hooks/useToggleCompanyInterest.ts
var useToggleCompanyInterest = __webpack_require__(79303);
;// CONCATENATED MODULE: ./src/app.feature/companyInfo/detail/mobile/header/CompanyInfoDetailHeader.tsx


function CompanyInfoDetailHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 16px 20px;\n    gap: 16px;\n\n    .company-info {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n\n      .company-logo {\n        width: 100px;\n        height: 80px;\n        padding: 15px 11px;\n        border-radius: 5px;\n        border: solid 1px ",
        ";\n        overflow: hidden;\n        flex-shrink: 0;\n        position: relative;\n        > img {\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n        }\n\n        .badge-hiring {\n          position: absolute;\n          top: 10px;\n          left: 10px;\n          background: #f46161;\n          color: ",
        ";\n          font-size: 11px;\n          font-weight: bold;\n          border-radius: 6px;\n          min-width: 37px;\n          height: 23px;\n          display: inline-flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n\n      .company-info-right {\n        flex: 1;\n        min-width: 0px;\n        .company-details {\n          margin-bottom: 5px;\n\n          > h1 {\n            font-size: 18px;\n            font-weight: bold;\n            line-height: 1.11;\n            margin-bottom: 3px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n\n          .company-type {\n            font-size: 12px;\n            line-height: 1.67;\n            letter-spacing: -0.48px;\n            color: ",
        ";\n            & > span:not(:last-child)::after {\n              content: '';\n              display: inline-block;\n              vertical-align: middle;\n              margin: 0 5px;\n              width: 1px;\n              height: 10px;\n              background-color: ",
        ";\n            }\n          }\n        }\n\n        .action-buttons {\n          display: flex;\n          gap: 5px;\n          > button {\n            background-color: ",
        ";\n            border: 1px solid ",
        ";\n            border-radius: 5px;\n            height: 28px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            &.like-button {\n              min-width: 78px;\n              font-size: 13px;\n              font-weight: bold;\n              gap: 2px;\n              color: ",
        ";\n            }\n            &.share-button {\n              padding: 6px;\n            }\n          }\n        }\n      }\n    }\n\n    .link-buttons {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      height: 36px;\n      gap: 8px;\n\n      > a,\n      button {\n        display: flex;\n        gap: 1px;\n        align-items: center;\n        justify-content: center;\n        border-radius: 5px;\n        background-color: #f2f6ff;\n        border: none;\n        font-size: 13px;\n        font-weight: 500;\n        letter-spacing: -0.52px;\n        color: ",
        ";\n        white-space: nowrap;\n      }\n    }\n  "
    ]);
    CompanyInfoDetailHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyInfoDetailHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    CompanyInfoDetailHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















var CompanyInfoDetailHeader = function(param) {
    var data = param.data;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var linkareer = (0,context/* useDomain */.ay)().linkareer;
    var checkLogin = (0,LoginAlertProvider/* useLoginAlert */.eZ)().checkLogin;
    var toggleCompanyInterest = (0,useToggleCompanyInterest/* default */.Z)().toggleCompanyInterest;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlShareCompanyMutation */.wzd)(), 1), shareCompany = ref6[0];
    var ref7 = (0,react.useState)(false), isModalOpen = ref7[0], setIsModalOpen = ref7[1];
    var ref8 = (0,react.useState)(false), openShareModal = ref8[0], setOpenShareModal = ref8[1];
    var handleClickLike = function(e) {
        e.stopPropagation();
        checkLogin(function() {
            var ref;
            if ((ref = data.company) === null || ref === void 0 ? void 0 : ref.id) {
                toggleCompanyInterest(data.company.id, data.viewerInterestedIn);
            }
        });
    };
    var handleCloseShareModal = function() {
        setOpenShareModal(false);
    };
    var handleClickShare = function() {
        setOpenShareModal(true);
    };
    var handleClickChatBtn = function() {
        setIsModalOpen(true);
    };
    var handleClickCloseModal = function() {
        setIsModalOpen(false);
    };
    var increaseCompanyShare = function() {
        var ref;
        if (!((ref = data.company) === null || ref === void 0 ? void 0 : ref.id)) {
            return;
        }
        shareCompany({
            variables: {
                companyId: data.company.id
            }
        });
    };
    var _companyType, ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyInfoDetailHeader_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "company-info",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "company-logo",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (ref = data.thumbnailImage) === null || ref === void 0 ? void 0 : ref.url,
                                alt: (ref1 = data.company) === null || ref1 === void 0 ? void 0 : ref1.name
                            }),
                            data.isRecruiting && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "badge-hiring",
                                children: "채용중"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "company-info-right",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "company-details",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: (ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "company-type",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: companyType/* COMPANY_TYPE_LABELS */.w[(_companyType = data.companyType) !== null && _companyType !== void 0 ? _companyType : ""]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: (ref3 = data.companyIndustry) === null || ref3 === void 0 ? void 0 : ref3.secondary
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "action-buttons",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "like-button",
                                        onClick: handleClickLike,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heart/* default */.Z, {
                                                width: 16,
                                                height: 16,
                                                isFilled: data.viewerInterestedIn
                                            }),
                                            (0,getLimitNumText/* getLimitNumText */.i)({
                                                number: (ref9 = (ref4 = data.company) === null || ref4 === void 0 ? void 0 : ref4.interestCount) !== null && ref9 !== void 0 ? ref9 : 0,
                                                limit: 9999
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "share-button",
                                        onClick: handleClickShare,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareLight/* default */.Z, {
                                            color: "#333"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "link-buttons",
                children: [
                    data.analysisReportId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "/company-analysis/".concat(data.analysisReportId),
                        target: "_blank",
                        rel: "noreferrer noopener",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalysisIcon/* default */.Z, {}),
                            " 기업분석자료"
                        ]
                    }),
                    data.chatRoomId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        onClick: handleClickChatBtn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatIcon/* default */.Z, {}),
                            " 실시간 채팅"
                        ]
                    }),
                    data.cbtExamId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat(config/* LINKAREER_ACADEMY_BASE_URL */.$K, "/exam/detail/").concat(data.cbtExamId),
                        target: "_blank",
                        rel: "noreferrer noopener",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CbtIcon/* default */.Z, {}),
                            " 인적성/필기"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal/* default */.Z, {
                shareLink: "https://".concat(linkareer, "/company-info/").concat(data === null || data === void 0 ? void 0 : data.id),
                open: openShareModal,
                onClose: handleCloseShareModal,
                onClick: increaseCompanyShare,
                ogImage: "https://linkareer.com/static/images/company-info.png",
                title: "".concat((ref5 = data.company) === null || ref5 === void 0 ? void 0 : ref5.name, " 채용정보 | 자소서\xb7합격후기\xb7면접후기\xb7Q&A - 링커리어")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatAppModal/* default */.Z, {
                open: isModalOpen,
                onClose: handleClickCloseModal,
                chatRoomId: data.chatRoomId || ""
            })
        ]
    });
};
/* harmony default export */ var header_CompanyInfoDetailHeader = (CompanyInfoDetailHeader);
var CompanyInfoDetailHeader_StyledWrapper = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    displayName: "CompanyInfoDetailHeader__StyledWrapper",
    componentId: "sc-ad0f0045-0"
})(CompanyInfoDetailHeader_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CompanyInfoDetailHeader_templateObject(), theme.background.bg_8, theme.line.line_3, theme.background.bg_8, theme.color.text_2, theme.line.line_2, theme.background.bg_8, theme.line.line_1, theme.color.text_1, theme.color.text_1);
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/app.feature/companyInfo/detail/constants/detailTabs.ts
var detailTabs = __webpack_require__(42337);
;// CONCATENATED MODULE: ./src/app.feature/companyInfo/detail/mobile/tabs/CompanyInfoDetailTabs.tsx


function CompanyInfoDetailTabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n    padding-top: 16px;\n    height: 50px;\n    display: flex;\n    gap: 17px;\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    width: 100%;\n    max-width: 100%;\n    border-bottom: 1px solid ",
        ";\n\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    .tab-button {\n      background: none;\n      border: none;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      position: relative;\n      transition: all 0.2s ease;\n      flex-shrink: 0;\n      white-space: nowrap;\n      padding-bottom: 11px;\n      color: ",
        ";\n\n      &:first-child {\n        margin-left: 20px;\n      }\n      &:last-child {\n        margin-right: 20px;\n      }\n\n      &.active {\n        .tab-name {\n          color: ",
        ";\n          font-weight: bold;\n        }\n\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          height: 2px;\n          background-color: ",
        ";\n        }\n      }\n    }\n\n    .tab-name {\n      font-size: 14px;\n      font-weight: 500;\n    }\n  "
    ]);
    CompanyInfoDetailTabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyInfoDetailTabs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    CompanyInfoDetailTabs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var CompanyInfoDetailTabs = function() {
    var router = (0,next_router.useRouter)();
    var activeTab = (0,detailTabs/* getCompanyInfoActiveTab */.$)(router.pathname);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyInfoDetailTabs_StyledWrapper, {
        children: Object.entries(detailTabs/* COMPANY_INFO_TABS */.y).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), tabKey = _param[0], tab = _param[1];
            var href = tabKey === "overview" ? "/company-info/".concat(router.query.id) : "/company-info/".concat(router.query.id, "/").concat(tabKey);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                shallow: false,
                scroll: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "tab-button ".concat(activeTab === tabKey ? "active" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "tab-name",
                        children: tab.name
                    })
                })
            }, tabKey);
        })
    });
};
/* harmony default export */ var tabs_CompanyInfoDetailTabs = (CompanyInfoDetailTabs);
var CompanyInfoDetailTabs_StyledWrapper = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    displayName: "CompanyInfoDetailTabs__StyledWrapper",
    componentId: "sc-d67f096a-0"
})(CompanyInfoDetailTabs_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CompanyInfoDetailTabs_templateObject(), theme.background.bg_8, theme.line.line_3, theme.color.text_1, theme.color.primary_2, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/companyInfo/detail/mobile/layout/CompanyInfoDetailLayoutMobile.tsx




function CompanyInfoDetailLayoutMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    CompanyInfoDetailLayoutMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var CompanyInfoDetailLayoutMobile = function(param) {
    var companyInformation = param.companyInformation, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlViewCompanyMutation */.Kzo)(), 1), viewCompany = ref7[0];
    (0,react.useEffect)(function() {
        if (companyInformation === null || companyInformation === void 0 ? void 0 : companyInformation.companyId) {
            viewCompany({
                variables: {
                    companyId: (companyInformation === null || companyInformation === void 0 ? void 0 : companyInformation.companyId) || ""
                }
            });
        }
    }, [
        viewCompany,
        companyInformation === null || companyInformation === void 0 ? void 0 : companyInformation.companyId
    ]);
    var ref8 = (0,graphql/* useGqlCompanyInformationNotCachedQueryQuery */.uZn)({
        variables: {
            companyInformationId: (companyInformation === null || companyInformation === void 0 ? void 0 : companyInformation.id) || ""
        },
        fetchPolicy: "cache-and-network",
        skip: !companyInformation
    }), csrData = ref8.data;
    var mergedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, companyInformation), {
        viewerInterestedIn: csrData === null || csrData === void 0 ? void 0 : (ref = csrData.companyInformation) === null || ref === void 0 ? void 0 : ref.viewerInterestedIn,
        company: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, companyInformation.company), {
            interestCount: (csrData === null || csrData === void 0 ? void 0 : (ref1 = csrData.companyInformation) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.company) === null || ref2 === void 0 ? void 0 : ref2.interestCount) || 0,
            viewCount: (csrData === null || csrData === void 0 ? void 0 : (ref3 = csrData.companyInformation) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.company) === null || ref4 === void 0 ? void 0 : ref4.viewCount) || 0,
            shareCount: (csrData === null || csrData === void 0 ? void 0 : (ref5 = csrData.companyInformation) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.company) === null || ref6 === void 0 ? void 0 : ref6.shareCount) || 0
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyInfoDetailLayoutMobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_CompanyInfoDetailHeader, {
                data: mergedData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_CompanyInfoDetailTabs, {}),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_CompanyInfoRelated, {
                companyId: companyInformation.companyId
            })
        ]
    });
};
/* harmony default export */ var layout_CompanyInfoDetailLayoutMobile = (CompanyInfoDetailLayoutMobile);
var CompanyInfoDetailLayoutMobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CompanyInfoDetailLayoutMobile__StyledWrapper",
    componentId: "sc-3e25f7a1-0"
})(CompanyInfoDetailLayoutMobile_templateObject());


/***/ }),

/***/ 90881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36957);
/* harmony import */ var svgIcons_Heart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80800);
/* harmony import */ var _detail_hooks_useToggleCompanyInterest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79303);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    cursor: pointer;\n\n    .company-logo-wrapper {\n      box-sizing: border-box;\n      width: 100%;\n      height: 180px;\n      background: ",
        ";\n      border: 1px solid ",
        ";\n      border-radius: 8px;\n      padding: 16px;\n      position: relative;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-bottom: 16px;\n\n      .badge-hiring {\n        position: absolute;\n        top: 16px;\n        left: 16px;\n        background: #f46161;\n        color: ",
        ";\n        font-size: 12px;\n        font-weight: bold;\n        border-radius: 6px;\n        min-width: 44px;\n        height: 24px;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n      .like-button {\n        position: absolute;\n        top: 16px;\n        right: 16px;\n        font-size: 20px;\n        color: #bbb;\n        cursor: pointer;\n        background: transparent;\n        border: none;\n      }\n      > img {\n        max-width: 190px;\n        max-height: 120px;\n        object-fit: contain;\n      }\n    }\n\n    .company-info-wrapper {\n      .company-name {\n        font-size: 16px;\n        font-weight: bold;\n        line-height: 1.5;\n        letter-spacing: -0.64px;\n        margin-bottom: 4px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n      .company-type {\n        font-size: 14px;\n        line-height: 1.71;\n        letter-spacing: -0.56px;\n        margin-bottom: 8px;\n        & > span:not(:last-child)::after {\n          content: '';\n          display: inline-block;\n          vertical-align: middle;\n          margin: 0 5px;\n          width: 1px;\n          height: 10px;\n          background-color: ",
        ";\n        }\n      }\n      .company-stats {\n        font-size: 13px;\n        color: ",
        ";\n        letter-spacing: -0.52px;\n        & > span:not(:last-child)::after {\n          content: '';\n          display: inline-block;\n          vertical-align: middle;\n          margin: 0 5px;\n          width: 1px;\n          height: 10px;\n          background-color: ",
        ";\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CompanyInfoCardVertical = function(param) {
    var data = param.data, checkLogin = param.checkLogin, relatedCompanyId = param.relatedCompanyId;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var toggleCompanyInterest = (0,_detail_hooks_useToggleCompanyInterest__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().toggleCompanyInterest;
    var handleClickCard = function() {
        router.push("/company-info/".concat(data.companyInformationId));
    };
    var handleClickLike = function(e) {
        e.stopPropagation();
        checkLogin(function() {
            toggleCompanyInterest(data.companyId, data.isLiked, relatedCompanyId);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        onClick: handleClickCard,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "company-logo-wrapper",
                children: [
                    data.isHiring && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "badge-hiring",
                        children: "채용중"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        type: "button",
                        "aria-label": "관심 설정",
                        className: "like-button",
                        onClick: handleClickLike,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_Heart__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            isFilled: data.isLiked
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        src: data.companyLogo,
                        alt: data.companyName
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "company-info-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                        className: "company-name",
                        children: data.companyName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "company-type",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: data.companyType
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: data.industryType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "company-stats",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                children: [
                                    "관심설정",
                                    " ",
                                    (0,components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_3__/* .getLimitNumText */ .i)({
                                        number: data.likesCount,
                                        limit: 9999
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                children: [
                                    "조회수",
                                    " ",
                                    (0,components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_3__/* .getLimitNumText */ .i)({
                                        number: data.viewsCount,
                                        limit: 9999
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CompanyInfoCardVertical__StyledWrapper",
    componentId: "sc-9482315f-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), theme.background.bg_8, theme.line.line_3, theme.background.bg_8, theme.line.line_2, theme.color.text_2, theme.line.line_2);
});
/* harmony default export */ __webpack_exports__["Z"] = (CompanyInfoCardVertical);


/***/ }),

/***/ 40697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);
/* harmony import */ var components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36957);
/* harmony import */ var svgIcons_Heart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80800);
/* harmony import */ var _detail_hooks_useToggleCompanyInterest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79303);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    cursor: pointer;\n\n    .company-logo-wrapper {\n      box-sizing: border-box;\n      width: 100%;\n      height: 107px;\n      background: ",
        ";\n      border: 1px solid ",
        ";\n      border-radius: 8px;\n      padding: 17px 20px;\n      position: relative;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-bottom: 12px;\n\n      .badge-hiring {\n        position: absolute;\n        top: 16px;\n        left: 16px;\n        background: #f46161;\n        color: ",
        ";\n        font-size: 12px;\n        font-weight: bold;\n        border-radius: 6px;\n        min-width: 37px;\n        height: 23px;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n      .like-button {\n        position: absolute;\n        top: 10px;\n        right: 10px;\n        font-size: 11px;\n        font-weight: bold;\n        cursor: pointer;\n        background: transparent;\n        border: none;\n      }\n      > img {\n        max-width: 123px;\n        max-height: 73px;\n        object-fit: contain;\n      }\n    }\n\n    .company-info-wrapper {\n      .company-name {\n        font-size: 15px;\n        font-weight: bold;\n        line-height: 1.5;\n        letter-spacing: -0.64px;\n        margin-bottom: 4px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n      .company-type {\n        font-size: 13px;\n        line-height: 1.85;\n        letter-spacing: -0.52px;\n        margin-bottom: 8px;\n        & > span:not(:last-child)::after {\n          content: '';\n          display: inline-block;\n          vertical-align: middle;\n          margin: 0 5px;\n          width: 1px;\n          height: 10px;\n          background-color: ",
        ";\n        }\n      }\n      .company-stats {\n        font-size: 13px;\n        color: ",
        ";\n        line-height: 1.85;\n        letter-spacing: -0.52px;\n        & > span:not(:last-child)::after {\n          content: '';\n          display: inline-block;\n          vertical-align: middle;\n          margin: 0 5px;\n          width: 1px;\n          height: 10px;\n          background-color: ",
        ";\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var CompanyInfoCardVertical = function(param) {
    var data = param.data, checkLogin = param.checkLogin, relatedCompanyId = param.relatedCompanyId;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var toggleCompanyInterest = (0,_detail_hooks_useToggleCompanyInterest__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().toggleCompanyInterest;
    var handleClickCard = function() {
        router.push("/company-info/".concat(data.companyInformationId));
    };
    var handleClickLike = function(e) {
        e.stopPropagation();
        checkLogin(function() {
            toggleCompanyInterest(data.companyId, data.isLiked, relatedCompanyId);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        onClick: handleClickCard,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "company-logo-wrapper",
                children: [
                    data.isHiring && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "badge-hiring",
                        children: "채용중"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                        type: "button",
                        className: "like-button",
                        onClick: handleClickLike,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_Heart__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            isFilled: data.isLiked,
                            width: 20,
                            height: 20
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        src: data.companyLogo,
                        alt: data.companyName
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "company-info-wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                        className: "company-name",
                        children: data.companyName
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "company-type",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: data.companyType
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                children: data.industryType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "company-stats",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                children: [
                                    "관심",
                                    " ",
                                    (0,components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_3__/* .getLimitNumText */ .i)({
                                        number: data.likesCount,
                                        limit: 9999
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                children: [
                                    "조회수 ",
                                    (0,components_ActivityListCardItem_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_3__/* .getLimitNumText */ .i)({
                                        number: data.viewsCount,
                                        limit: 9999
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CompanyInfoCardVertical__StyledWrapper",
    componentId: "sc-d95952c4-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), theme.background.bg_8, theme.line.line_3, theme.background.bg_8, theme.line.line_2, theme.color.text_2, theme.line.line_2);
});
/* harmony default export */ __webpack_exports__["Z"] = (CompanyInfoCardVertical);


/***/ }),

/***/ 17251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants_companyType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89064);

var formatCompanyInfoCardData = function(companies) {
    return companies.map(function(company) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        return {
            companyInformationId: ((ref = company.companyInformation) === null || ref === void 0 ? void 0 : ref.id) || "",
            companyId: company.id,
            companyName: company.name,
            companyLogo: ((ref1 = company.companyInformation) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.thumbnailImage) === null || ref2 === void 0 ? void 0 : ref2.url) || "",
            isHiring: ((ref3 = company.companyInformation) === null || ref3 === void 0 ? void 0 : ref3.isRecruiting) || false,
            isLiked: ((ref4 = company.companyInformation) === null || ref4 === void 0 ? void 0 : ref4.viewerInterestedIn) || false,
            companyType: _constants_companyType__WEBPACK_IMPORTED_MODULE_0__/* .COMPANY_TYPE_LABELS */ .w[((ref5 = company.companyInformation) === null || ref5 === void 0 ? void 0 : ref5.companyType) || ""] || "",
            industryType: ((ref6 = company.companyInformation) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.companyIndustry) === null || ref7 === void 0 ? void 0 : ref7.secondary) || "",
            likesCount: company.interestCount,
            viewsCount: company.viewCount
        };
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (formatCompanyInfoCardData);


/***/ }),

/***/ 36957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ getLimitNumText; }
/* harmony export */ });
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93293);

var getLimitNumText = function(param) {
    var number = param.number, limit = param.limit;
    if (number <= limit) {
        return (0,utils__WEBPACK_IMPORTED_MODULE_0__/* .numberWithCommas */ .x6)(number);
    } else {
        return "".concat((0,utils__WEBPACK_IMPORTED_MODULE_0__/* .numberWithCommas */ .x6)(limit), "+");
    }
};


/***/ }),

/***/ 80800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var Heart = function(_param) /*#__PURE__*/ {
    var _isFilled = _param.isFilled, isFilled = _isFilled === void 0 ? false : _isFilled, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "isFilled"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "관심"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                fill: "none",
                "data-name": "그룹 50632",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M0 0h24v24H0z",
                        "data-name": "사각형 34551"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        stroke: isFilled ? "#f46161" : "#666",
                        fill: isFilled ? "#f46161" : "none",
                        strokeLinejoin: "round",
                        strokeWidth: "1.2",
                        d: "M18.121 3.396c-2.3-.717-4.6 1.338-6.125 3.2-1.52-1.858-3.853-3.945-6.125-3.2-2.981 1.142-4.215 5.007-3.069 8.256s9.194 9.107 9.194 9.107 8.048-5.859 9.194-9.107a7.26 7.26 0 0 0-.567-6.153 4.77 4.77 0 0 0-2.502-2.103z",
                        "data-name": "패스 17408"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heart);


/***/ }),

/***/ 32685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function ShareLight(param) {
    var _color = param.color, color = _color === void 0 ? "#777" : _color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        "aria-label": "공유",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "공유"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "j0vm8zlzra",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        stroke: color,
                        d: "M0 0h20v20H0z",
                        "data-name": "사각형 3303",
                        transform: "translate(1432.5 570.5)"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#j0vm8zlzra)",
                "data-name": "마스크 그룹 98",
                transform: "translate(-1432.5 -570.5)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    "data-name": "share-2 (1)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "none",
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: "1.2",
                        d: "M1444 585.1a2 2 0 112 2 2 2 0 01-2-2zm-4.239-3.6a2 2 0 11.239-.95 2 2 0 01-.24.951l4.52 2.568zm4.479-4.549A2 2 0 111446 578a1.99 1.99 0 01-1.76-1.049l-4.513 2.568z",
                        "data-name": "합치기 92"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ShareLight);


/***/ }),

/***/ 82379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var AnalysisIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "기업분석자료 아이콘"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M0 0h20v20H0z",
                "data-name": "사각형 34605"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "data-name": "그룹 50898",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#01a0ff",
                        d: "M5.056 2.445h8.572a.4.4 0 0 1 .276.157l2.238 2.918a.43.43 0 0 1 .114.271l-.031 10.451a1.314 1.314 0 0 1-1.314 1.314H5.056a1.314 1.314 0 0 1-1.314-1.311V3.758a1.314 1.314 0 0 1 1.314-1.313",
                        "data-name": "패스 16135"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        fill: "#fff",
                        "data-name": "그룹 47279",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M9.677 7.097a3.2 3.2 0 1 0 3.2 3.2q-.002-.075-.008-.149H9.677z",
                                "data-name": "패스 16133"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M10.567 6.501v2.826h2.957a2.965 2.965 0 0 0-2.957-2.826",
                                "data-name": "패스 16134"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AnalysisIcon);


/***/ }),

/***/ 92788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var CbtIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "인적성/필기 아이콘"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "dvb9mc3h0b",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                        xlinkHref: "#bnouetolpa"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M0 0h20v20H0z",
                "data-name": "사각형 34606"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                "data-name": "그룹 50901",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        "data-name": "그룹 47253",
                        transform: "translate(2.371 2.792)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                width: "4",
                                height: "3",
                                fill: "#01a0ff",
                                "data-name": "사각형 32100",
                                rx: "1.5",
                                transform: "translate(6 10.999)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fill: "#4a7bff",
                                d: "M4.439 14.003a.5.5 0 0 1-.217-.95l1.238-.594v-1.356h5.63v1.352l1.237.594a.5.5 0 0 1-.217.95z",
                                "data-name": "합치기 298"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                fill: "#4a7bff",
                                stroke: "#4a7bff",
                                "data-name": "사각형 32099",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                        width: "16",
                                        height: "12",
                                        stroke: "none",
                                        rx: "2"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                        width: "15",
                                        height: "11",
                                        x: "0.5",
                                        y: "0.5",
                                        fill: "none",
                                        rx: "1.5"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        "data-name": "그룹 47254",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                "data-name": "그룹 16069",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                    "data-name": "그룹 16095",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                            "data-name": "그룹 15920",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                fill: "none",
                                                d: "M7.364 5.987h5.8v5.8h-5.8z",
                                                "data-name": "사각형 12761"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                            "data-name": "그룹 16016",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                                "data-name": "그룹 15988",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    fill: "#fff",
                                                    stroke: "#fff",
                                                    strokeLinejoin: "round",
                                                    d: "M7.896 9.905v1.137h1.1l3.047-2.654-1.279-1.2z",
                                                    "data-name": "패스 8449"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                fill: "#fff",
                                stroke: "#fff",
                                "data-name": "사각형 31979",
                                transform: "rotate(43 -1.675 17.527)",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                        id: "bnouetolpa",
                                        width: "2.563",
                                        height: "0.644",
                                        stroke: "none",
                                        rx: "0.322"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "none",
                                        d: "M0 .144h2.563M2.063 0v.644m.5-.144H0m.5.144V0",
                                        clipPath: "url(#dvb9mc3h0b)"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CbtIcon);


/***/ }),

/***/ 99119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var ChatIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("desc", {
                children: "실시간 채팅 아이콘"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "xrqmtcpgca",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        stroke: "#707070",
                        strokeWidth: "1.2",
                        d: "M-.371 0h20v20h-20z",
                        "data-name": "사각형 34506"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#xrqmtcpgca)",
                "data-name": "icon / 20 / chat",
                transform: "translate(.371)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    "data-name": "그룹 50542",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            "data-name": "그룹 50539",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                "data-name": "그룹 50538",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                        fill: "#d4d4d4",
                                        "data-name": "합치기 389",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M8.584 14.776a5.8 5.8 0 0 1-3.65-1.273l-.218-.174-.273.055-1.076.214a.4.4 0 0 1-.393-.145.4.4 0 0 1-.074-.34l.345-1.466.046-.196-.08-.183a5.872 5.872 0 0 1 5.373-8.222 5.87 5.87 0 0 1 5.865 5.866 5.87 5.87 0 0 1-5.865 5.864"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M8.584 14.176a5.27 5.27 0 0 0 5.265-5.264 5.27 5.27 0 0 0-5.265-5.266 5.272 5.272 0 0 0-4.824 7.38l.161.368-.366 1.555 1.317-.262.435.346a5.2 5.2 0 0 0 3.277 1.143m0 1.2a6.44 6.44 0 0 1-4.024-1.404l-1.076.215a1 1 0 0 1-1.168-1.211l.345-1.467a6.466 6.466 0 1 1 5.922 3.867z"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        fill: "#ddd",
                                        d: "M11.41 5.525a5.956 5.956 0 0 1 6.079 5.825 5.956 5.956 0 0 1-6.079 5.825 5.956 5.956 0 0 1-6.079-5.825 5.956 5.956 0 0 1 6.079-5.825",
                                        "data-name": "합치기 390"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            "data-name": "그룹 50541",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                    "data-name": "그룹 50540",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                        fill: "#ffbb01",
                                        "data-name": "합치기 391",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M11.122 17.239a5.87 5.87 0 0 1-5.866-5.864 5.87 5.87 0 0 1 5.866-5.866 5.87 5.87 0 0 1 5.865 5.866 5.86 5.86 0 0 1-.793 2.947l-.127.217.066.243.38 1.39a.4.4 0 0 1-.068.347.39.39 0 0 1-.381.152l-1.65-.268-.208-.034-.185.105c-.879.5-1.881.765-2.9.765z"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M11.122 16.639c.914 0 1.814-.237 2.602-.686l.369-.21 1.759.286-.43-1.574.253-.435a5.26 5.26 0 0 0 .712-2.645 5.27 5.27 0 0 0-5.265-5.266 5.27 5.27 0 0 0-5.266 5.266 5.27 5.27 0 0 0 5.266 5.264m0 1.2a6.466 6.466 0 1 1 5.59-3.215l.38 1.39a1 1 0 0 1-1.126 1.25l-1.648-.269a6.44 6.44 0 0 1-3.196.844"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fill: "none",
                                    stroke: "#fff",
                                    strokeLinecap: "round",
                                    strokeWidth: "1.2",
                                    d: "M8.351 10.522h5.542",
                                    "data-name": "선 2126"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fill: "none",
                                    stroke: "#fff",
                                    strokeLinecap: "round",
                                    strokeWidth: "1.2",
                                    d: "M8.351 12.369h3.695",
                                    "data-name": "선 2127"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ChatIcon);


/***/ }),

/***/ 45363:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
__webpack_unused_export__ = ({ value: true });
exports.h6 = exports.hg = __webpack_unused_export__ = void 0;
var json_ld_1 = __webpack_require__(82342);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.helmetJsonLdProp; } });
Object.defineProperty(exports, "hg", ({ enumerable: true, get: function () { return json_ld_1.JsonLd; } }));
Object.defineProperty(exports, "h6", ({ enumerable: true, get: function () { return json_ld_1.jsonLdScriptProps; } }));


/***/ }),

/***/ 82342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helmetJsonLdProp = exports.jsonLdScriptProps = exports.JsonLd = void 0;
const React = __webpack_require__(67294);
function JsonLd(props) {
    return React.createElement("script", Object.assign({}, jsonLdScriptProps(props.item, props)));
}
exports.JsonLd = JsonLd;
function jsonLdScriptProps(item, options = {}) {
    return {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(item, safeJsonLdReplacer, options.space),
        },
    };
}
exports.jsonLdScriptProps = jsonLdScriptProps;
function helmetJsonLdProp(item, options = {}) {
    return {
        type: "application/ld+json",
        innerHTML: JSON.stringify(item, safeJsonLdReplacer, options.space),
    };
}
exports.helmetJsonLdProp = helmetJsonLdProp;
const ESCAPE_ENTITIES = Object.freeze({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&apos;",
});
const ESCAPE_REGEX = new RegExp(`[${Object.keys(ESCAPE_ENTITIES).join("")}]`, "g");
const ESCAPE_REPLACER = (t) => ESCAPE_ENTITIES[t];
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
const safeJsonLdReplacer = (() => {
    // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
    // Solution from https://stackoverflow.com/a/5499821/864313
    return (_, value) => {
        switch (typeof value) {
            case "object":
                // Omit null values.
                if (value === null) {
                    return undefined;
                }
                return value; // JSON.stringify will recursively call replacer.
            case "number":
            case "boolean":
            case "bigint":
                return value; // These values are not risky.
            case "string":
                return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
            default: {
                // We shouldn't expect other types.
                isNever(value);
                // JSON.stringify will remove this element.
                return undefined;
            }
        }
    };
})();
// Utility: Assert never
function isNever(_) { }


/***/ })

}]);